<div class="analytics-page">
  <header class="page-header">
    <h1>{{ 'reporting_analytics.title' | translate }}</h1>
  </header>

  <nav class="module-tabs" aria-label="Reporting sections">
    <button type="button" [class.active]="activeModuleTab === 'chat'" (click)="setModuleTab('chat')">{{ 'reporting_analytics.tab_chat' | translate }}</button>
    <button type="button" [class.active]="activeModuleTab === 'reports'" (click)="setModuleTab('reports')">{{ 'reporting_analytics.tab_reports' | translate }}</button>
    <button type="button" [class.active]="activeModuleTab === 'subscriptions'" (click)="setModuleTab('subscriptions')">{{ 'reporting_analytics.tab_subscription' | translate }}</button>
    <button type="button" [class.active]="activeModuleTab === 'archive'" (click)="setModuleTab('archive')">{{ 'reporting_analytics.tab_archive' | translate }}</button>
  </nav>

  <ng-container *ngIf="activeModuleTab === 'chat'">
    <div class="workspace">
      <aside class="saved-queries">
        <div class="sidebar-heading">
          <span>{{ 'reporting_analytics.saved_queries' | translate }}</span>
          <button type="button" [attr.aria-label]="'reporting_analytics.new_query' | translate" (click)="newSession()">＋</button>
        </div>

        <label class="search-field">
          <i class="pi pi-search"></i>
          <input
            type="search"
            [ngModel]="search"
            (ngModelChange)="onSearchChange($event)"
            [placeholder]="'reporting_analytics.search' | translate" />
        </label>

        <div class="sessions-scroll">
          <p class="sidebar-note" *ngIf="sessionsError">{{ 'reporting_analytics.sessions_unavailable' | translate }}</p>
          <p class="sidebar-note" *ngIf="!sessionsError && !sessionsLoading && !sessions.length">
            {{ 'reporting_analytics.no_sessions' | translate }}
          </p>

          <section class="query-section" *ngIf="starredSessions.length">
            <h2>{{ 'reporting_analytics.starred' | translate }}</h2>
            <ng-container *ngFor="let session of starredSessions">
              <ng-container *ngTemplateOutlet="sessionCard; context: { $implicit: session }"></ng-container>
            </ng-container>
          </section>

          <section class="query-section" *ngIf="recentSessions.length">
            <h2>{{ 'reporting_analytics.all_queries' | translate }}</h2>
            <ng-container *ngFor="let session of recentSessions">
              <ng-container *ngTemplateOutlet="sessionCard; context: { $implicit: session }"></ng-container>
            </ng-container>
          </section>
        </div>

        <button type="button" class="new-query" (click)="newSession()">
          <i class="pi pi-plus"></i>
          {{ 'reporting_analytics.new_query' | translate }}
        </button>

        <ng-template #sessionCard let-session>
          <div
            class="query-card"
            role="button"
            tabindex="0"
            [class.active]="session.session_id === sessionId"
            (click)="openSession(session)"
            (keydown.enter)="openSession(session)">
            <span class="query-card-body">
              <ng-container *ngIf="renamingSessionId !== session.session_id; else renameField">
                <strong [title]="sessionTitle(session)">{{ sessionTitle(session) }}</strong>
                <small>{{ session.updated_at_utc | date: 'dd.MM.yyyy HH:mm' }} · {{ session.message_count }}</small>
              </ng-container>
              <ng-template #renameField>
                <input
                  class="rename-input"
                  type="text"
                  [(ngModel)]="renameDraft"
                  (click)="$event.stopPropagation()"
                  (keydown.enter)="commitRename(session)"
                  (keydown.escape)="cancelRename()"
                  (blur)="commitRename(session)" />
              </ng-template>
            </span>
            <span class="query-card-actions">
              <button
                type="button"
                class="star"
                [class.on]="session.starred"
                [attr.aria-label]="'reporting_analytics.action_star' | translate"
                [title]="'reporting_analytics.action_star' | translate"
                (click)="toggleStar(session, $event)">
                <i class="pi" [class.pi-star-fill]="session.starred" [class.pi-star]="!session.starred"></i>
              </button>
              <button
                type="button"
                [attr.aria-label]="'reporting_analytics.action_rename' | translate"
                [title]="'reporting_analytics.action_rename' | translate"
                (click)="startRename(session, $event)">
                <i class="pi pi-pencil"></i>
              </button>
              <button
                type="button"
                [attr.aria-label]="'reporting_analytics.action_archive' | translate"
                [title]="'reporting_analytics.action_archive' | translate"
                (click)="archiveSession(session, $event)">
                <i class="pi pi-inbox"></i>
              </button>
              <button
                type="button"
                class="danger"
                [attr.aria-label]="'reporting_analytics.action_delete' | translate"
                [title]="'reporting_analytics.action_delete' | translate"
                (click)="deleteSession(session, $event)">
                <i class="pi pi-trash"></i>
              </button>
            </span>
          </div>
        </ng-template>
      </aside>

      <main class="chat-panel">
        <div class="banner" *ngIf="llmUnavailable">{{ 'reporting_analytics.unavailable' | translate }}</div>

        <div class="history-loading" *ngIf="loadingHistory && !messages.length">
          <i class="pi pi-spin pi-spinner"></i> {{ 'reporting_analytics.loading_history' | translate }}
        </div>

        <div class="empty-state" *ngIf="!hasConversation">
          <img src="/assets/reporting-analytics/assistant-4.png" alt="" />
          <h2>{{ 'reporting_analytics.greeting' | translate }}</h2>
          <p>{{ 'reporting_analytics.greeting_hint' | translate }}<br />{{ 'reporting_analytics.greeting_example' | translate }}</p>
          <div class="suggestions">
            <button type="button" (click)="sendPrompt('reporting_analytics.prompt_weather')">
              <i class="pi pi-cloud"></i> {{ 'reporting_analytics.prompt_samarkand' | translate }}
            </button>
            <button type="button" (click)="sendPrompt('reporting_analytics.prompt_ndvi')">
              <i class="pi pi-sparkles"></i> {{ 'reporting_analytics.prompt_fergana' | translate }}
            </button>
            <button type="button" (click)="sendPrompt('reporting_analytics.prompt_yield')">
              <i class="pi pi-chart-line"></i> {{ 'reporting_analytics.prompt_yield' | translate }}
            </button>
          </div>
        </div>

        <div class="feed" #feed *ngIf="messages.length">
          <article
            *ngFor="let message of messages"
            class="message"
            [class.user-message]="message.role === 'user'"
            [class.assistant-message]="message.role === 'assistant'">
            <div class="message-time">{{ message.time | date: 'HH:mm' }}</div>
            <div class="assistant-meta" *ngIf="message.role === 'assistant'">
              <img src="/assets/reporting-analytics/assistant-4.png" alt="" />
              <span>{{ 'reporting_analytics.assistant' | translate }}</span>
            </div>
            <div class="message-body" *ngIf="message.role === 'user'">{{ message.text }}</div>
            <div
              class="message-body"
              *ngIf="message.role === 'assistant'"
              [class.message-error]="message.error && !message.artifacts?.datasets?.length"
              [innerHTML]="message.text | markdown"></div>

            <ng-container *ngIf="message.artifacts as artifacts">
              <div class="error-card" *ngFor="let error of artifacts.errors">
                {{ errorText(error.code, error.user_message_ru, error.user_message_uz, error.message) }}
              </div>
              <div class="file-actions" *ngIf="artifacts.files.length">
                <button type="button" *ngFor="let file of artifacts.files" (click)="downloadArtifact(file)">
                  <i class="pi pi-download"></i> {{ file.file_name || file.format }}
                </button>
              </div>
              <ng-container *ngFor="let file of artifacts.files">
                <button
                  type="button"
                  class="image-artifact"
                  *ngIf="isImageArtifact(file) && imagePreview(file) as preview"
                  (click)="downloadArtifact(file)">
                  <img [src]="preview" [alt]="file.file_name || 'Generated chart'" />
                </button>
              </ng-container>
              <button type="button" class="audit-toggle" *ngIf="message.tool_calls?.length" (click)="toggleAudit(message.id)">
                {{ 'reporting_analytics.tool_calls' | translate }}
              </button>
              <div class="audit" *ngIf="auditOpen.has(message.id)">
                <div *ngFor="let tool of message.tool_calls">{{ tool.tool }} — {{ tool.summary }}</div>
              </div>
            </ng-container>
          </article>
          <div
            class="typing"
            *ngIf="sending"
            role="status"
            aria-live="polite"
            [attr.aria-label]="'reporting_analytics.waiting_reply' | translate">
            <span></span><span></span><span></span>
          </div>
        </div>

        <form class="composer" (ngSubmit)="send()">
          <div class="composer-main">
            <input
              [(ngModel)]="draft"
              name="draft"
              [disabled]="sending"
              [placeholder]="composerPlaceholderKey | translate" />
            <button type="button" class="attach" aria-label="Прикрепить файл"><i class="pi pi-paperclip"></i></button>
            <button type="submit" class="send-button" [disabled]="sending || !draft.trim()">
              <i class="pi pi-send"></i>
              {{ 'reporting_analytics.send' | translate }}
            </button>
          </div>
          <div class="mode-switch" role="group">
            <button type="button" [class.active]="!constructorMode" (click)="setConstructorMode(false)">
              {{ 'reporting_analytics.mode_agent' | translate }}
            </button>
            <button type="button" [class.active]="constructorMode" (click)="setConstructorMode(true)">
              {{ 'reporting_analytics.mode_constructor' | translate }}
            </button>
          </div>
        </form>
      </main>

      <aside class="results-panel">
        <nav class="result-tabs">
          <button type="button" [class.active]="activeResultTab === 'data'" (click)="setResultTab('data')">
            <i class="pi pi-clipboard"></i> {{ 'reporting_analytics.data' | translate }}
          </button>
          <button type="button" [class.active]="activeResultTab === 'map'" (click)="setResultTab('map')">
            <i class="pi pi-map"></i> {{ 'reporting_analytics.map' | translate }}
          </button>
          <button type="button" [class.active]="activeResultTab === 'chart'" (click)="setResultTab('chart')">
            <i class="pi pi-chart-line"></i> {{ 'reporting_analytics.chart' | translate }}
          </button>
        </nav>

        <div class="data-pane" *ngIf="activeResultTab === 'data'">
          <div class="export-buttons">
            <button type="button" (click)="exportFile('csv')"><i class="pi pi-download"></i> CSV</button>
            <button type="button" (click)="exportFile('excel')"><i class="pi pi-download"></i> Excel</button>
            <button type="button" (click)="exportFile('xls')"><i class="pi pi-download"></i> XLS</button>
            <button type="button" (click)="exportFile('html')"><i class="pi pi-download"></i> HTML</button>
            <button type="button" (click)="exportFile('pdf')"><i class="pi pi-download"></i> PDF</button>
            <button type="button" (click)="exportFile('docx')"><i class="pi pi-download"></i> DOCX</button>
            <button type="button" (click)="exportFile('geojson')"><i class="pi pi-download"></i> GeoJSON</button>
          </div>
          <p class="column-note column-note--error" *ngIf="composeError">{{ composeError }}</p>

          <div class="column-picker" *ngIf="constructorMode && !sections.length">
            <div class="document-fields document-fields--filters">
              <label>
                {{ constructorText('constructor_template_name') }}
                <input [(ngModel)]="templateName" name="templateNameEmpty" />
              </label>
              <label>
                {{ constructorText('constructor_template') }}
                <select [(ngModel)]="selectedTemplateId" name="selectedTemplateIdEmpty" (ngModelChange)="onTemplatePicked($event)">
                  <option value=""></option>
                  <option *ngFor="let item of savedTemplates" [value]="item.template_id">{{ item.title }}</option>
                </select>
              </label>
            </div>
            <div class="template-actions">
              <button type="button" class="refresh-data" (click)="openTemplate()" [disabled]="openingTemplate || !selectedTemplateId">
                {{ constructorText('constructor_open_template') }}
              </button>
            </div>
            <p class="column-note" *ngIf="composeError">{{ composeError }}</p>
            <p class="column-note">{{ constructorText('constructor_no_dataset') }}</p>
          </div>

          <div class="column-picker" *ngIf="constructorMode && sections.length">
            <div class="document-fields">
              <label>
                {{ constructorText('constructor_title') }}
                <input [(ngModel)]="documentTitle" name="documentTitle" (input)="markDocumentTitleEdited()" />
              </label>
              <label>
                {{ constructorText('constructor_period_from') }}
                <input type="date" [(ngModel)]="periodFrom" name="periodFrom" />
              </label>
              <label>
                {{ constructorText('constructor_period_to') }}
                <input type="date" [(ngModel)]="periodTo" name="periodTo" />
              </label>
            </div>
            <div class="document-fields document-fields--filters">
              <label>
                {{ constructorText('constructor_region') }}
                <select [(ngModel)]="filterGeoId" name="filterGeoId">
                  <option value=""></option>
                  <option *ngFor="let region of regionOptions" [value]="region.id">{{ region.label }}</option>
                </select>
              </label>
              <label>
                {{ constructorText('constructor_crop') }}
                <select [(ngModel)]="filterCropId" name="filterCropId">
                  <option value="">{{ constructorText('constructor_crop_any') }}</option>
                  <option *ngFor="let crop of cropOptions" [value]="crop.id">{{ crop.label }}</option>
                </select>
              </label>
            </div>
            <button type="button" class="refresh-data" (click)="refreshSections()" [disabled]="refreshing">
              {{ constructorText('constructor_refresh') }}
            </button>
            <div class="document-fields document-fields--filters">
              <label>
                {{ constructorText('constructor_template_name') }}
                <input [(ngModel)]="templateName" name="templateName" />
              </label>
              <label>
                {{ constructorText('constructor_template') }}
                <select [(ngModel)]="selectedTemplateId" name="selectedTemplateId" (ngModelChange)="onTemplatePicked($event)">
                  <option value=""></option>
                  <option *ngFor="let item of savedTemplates" [value]="item.template_id">{{ item.title }}</option>
                </select>
              </label>
            </div>
            <label class="template-check">
              <input type="checkbox" [(ngModel)]="subscribeTemplate" name="subscribeTemplate" />
              {{ constructorText('constructor_subscribe') }}
            </label>
            <div class="template-subscribe" *ngIf="subscribeTemplate">
              <div class="weekday-row">
                <label *ngFor="let day of subscribeWeekdays">
                  <input type="checkbox" [checked]="subscribeDays.includes(day.id)" (change)="toggleSubscribeDay(day.id)" />
                  {{ day.label }}
                </label>
              </div>
              <label>
                {{ constructorText('constructor_subscribe_time') }}
                <input type="time" [(ngModel)]="subscribeTime" name="subscribeTime" />
              </label>
              <div class="format-row">
                <label><input type="radio" name="subscribeFormat" value="pdf" [(ngModel)]="subscribeFormat" /> PDF</label>
                <label><input type="radio" name="subscribeFormat" value="xlsx" [(ngModel)]="subscribeFormat" /> Excel</label>
                <label><input type="radio" name="subscribeFormat" value="html" [(ngModel)]="subscribeFormat" /> HTML</label>
                <label><input type="radio" name="subscribeFormat" value="csv" [(ngModel)]="subscribeFormat" /> CSV</label>
              </div>
              <label class="template-check">
                <input type="checkbox" [(ngModel)]="subscribeOnNewPass" name="subscribeOnNewPass" />
                {{ constructorText('constructor_subscribe_pass') }}
              </label>
            </div>
            <div class="template-actions">
              <button type="button" class="refresh-data" (click)="saveTemplate()" [disabled]="savingTemplate || !sections.length">
                {{ constructorText('constructor_save_template') }}
              </button>
              <button type="button" class="refresh-data" (click)="openTemplate()" [disabled]="openingTemplate || !selectedTemplateId">
                {{ constructorText('constructor_open_template') }}
              </button>
            </div>
            <p class="column-note column-note--error" *ngIf="columnError">{{ constructorText('constructor_pick_one') }}</p>
            <p class="column-note column-note--error" *ngIf="composeError">{{ composeError }}</p>
            <p class="column-note column-note--ok" *ngIf="composeNotice">{{ composeNotice }}</p>
            <div class="column-picker-head" *ngIf="addableDatasets.length">
              <label>
                {{ constructorText('constructor_add_section') }}
                <select [(ngModel)]="pendingDatasetId" name="pendingDatasetId">
                  <option value="">{{ constructorText('constructor_pick_dataset') }}</option>
                  <option *ngFor="let dataset of addableDatasets" [value]="dataset.dataset_id">{{ datasetLabel(dataset) }}</option>
                </select>
              </label>
              <button type="button" (click)="addPendingSection()" [disabled]="!pendingDatasetId">
                {{ constructorText('constructor_add') }}
              </button>
            </div>
            <article class="constructor-section" *ngFor="let section of sections">
              <div class="column-picker-head">
                <label>
                  {{ constructorText('constructor_section_title') }}
                  <input
                    [(ngModel)]="section.title"
                    [name]="'sectionTitle' + section.datasetId"
                    (ngModelChange)="rememberSectionTitle(section)"
                    (input)="markSectionTitleEdited(section)" />
                </label>
                <button
                  type="button"
                  *ngIf="sectionIdentifiers(section).length"
                  [class.active]="sectionHasAllIdentifiers(section)"
                  [title]="constructorText('constructor_ids_hint')"
                  (click)="toggleSectionIdentifiers(section)">
                  {{ constructorText(sectionHasAllIdentifiers(section) ? 'constructor_ids_remove' : 'constructor_ids') }}
                </button>
                <button type="button" [title]="constructorText('constructor_all_hint')" (click)="applySectionPreset(section)">
                  {{ constructorText('constructor_all') }}
                </button>
                <button type="button" *ngIf="sections.length > 1" (click)="removeSection(section.datasetId)">{{ constructorText('constructor_remove_section') }}</button>
              </div>
              <div class="column-options">
                <label *ngFor="let column of visibleCatalog(section)">
                  <input
                    type="checkbox"
                    [checked]="section.selectedKeys.includes(column.key)"
                    (change)="toggleSectionColumn(section, column.key, $event)" />
                  {{ columnLabel(column) }}
                </label>
              </div>
              <p class="column-note" *ngIf="sectionMissingSelection(section)">{{ constructorText('constructor_preview_note') }}</p>
              <div class="data-table-wrap section-table">
                <table>
                  <thead>
                    <tr>
                      <th
                        *ngFor="let column of sectionColumns(section)"
                        class="draggable"
                        [class.dragging]="draggingSectionId === section.datasetId && draggingColumn === column"
                        [class.drag-over]="draggingSectionId === section.datasetId && dragOverColumn === column"
                        draggable="true"
                        (dragstart)="onSectionDragStart(section, column, $event)"
                        (dragover)="onColumnDragOver(column, $event)"
                        (drop)="onSectionDrop(section, column, $event)"
                        (dragend)="onColumnDragEnd()">
                        <i class="pi pi-bars drag-handle"></i>{{ columnLabelForKey(column, section.catalog) }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let row of section.previewRows">
                      <td *ngFor="let column of sectionColumns(section)">{{ datasetCell(row, column) }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </article>
            <p class="column-note" *ngIf="sections.length">{{ constructorText('constructor_drag_hint') }}</p>
          </div>

          <div class="data-table-wrap" *ngIf="!constructorMode && latestDataset as dataset">
            <table>
              <thead>
                <tr>
                  <th
                    *ngFor="let column of visibleColumns"
                    [class.draggable]="canReorderColumns"
                    [class.dragging]="draggingColumn === column"
                    [class.drag-over]="dragOverColumn === column"
                    [attr.draggable]="canReorderColumns ? true : null"
                    (dragstart)="onColumnDragStart(column, $event)"
                    (dragover)="onColumnDragOver(column, $event)"
                    (drop)="onColumnDrop(column, $event)"
                    (dragend)="onColumnDragEnd()">
                    <i class="pi pi-bars drag-handle" *ngIf="canReorderColumns"></i>{{ columnLabelForKey(column) }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let row of dataset.preview_rows">
                  <td *ngFor="let column of visibleColumns">{{ datasetCell(row, column) }}</td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="result-empty" *ngIf="!constructorMode && !latestDataset">
            <i class="pi pi-table"></i>
            <p>{{ 'reporting_analytics.no_data' | translate }}</p>
          </div>

          <div class="table-footer" *ngIf="latestDataset">
            {{ 'reporting_analytics.table_footer' | translate: { total: datasetTotal, shown: latestDataset.preview_rows.length } }}
          </div>
        </div>

        <div class="map-pane" *ngIf="hasMap" [hidden]="activeResultTab !== 'map'">
          <p class="map-stale" *ngIf="activeMap.stale">{{ 'reporting_analytics.map_stale' | translate }}</p>
          <app-analytics-map-card #mapCard [maps]="activeMap.maps" [dataset]="activeMap.dataset || latestDataset"></app-analytics-map-card>
        </div>
        <div class="result-empty" *ngIf="activeResultTab === 'map' && !hasMap">
          <i class="pi pi-map"></i>
          <p>{{ 'reporting_analytics.no_map' | translate }}</p>
        </div>

        <ng-container *ngIf="activeResultTab === 'chart'">
          <app-chart-card *ngIf="latestChart as chart; else noChart" [chart]="chart"></app-chart-card>
          <ng-template #noChart>
            <div class="result-empty">
              <i class="pi pi-chart-line"></i>
              <p>{{ 'reporting_analytics.no_chart' | translate }}</p>
            </div>
          </ng-template>
        </ng-container>
      </aside>
    </div>

    <section class="job-queue">
      <h2>{{ 'reporting_analytics.job_queue' | translate }}</h2>
      <div class="queue-list" *ngIf="allJobs.length; else emptyQueue">
        <div class="queue-item" *ngFor="let job of allJobs">
          <strong>{{ jobLabel(job) }}</strong>
          <div class="progress"><span [style.width.%]="jobProgress(job)"></span></div>
          <span>{{ jobProgress(job) }}%</span>
          <span class="status" [attr.data-status]="job.status">{{ job.status }}</span>
          <button type="button" *ngIf="job.status === 'done'" (click)="downloadJob(job)"><i class="pi pi-download"></i></button>
          <button type="button" *ngIf="job.status === 'failed'" (click)="retryJob()"><i class="pi pi-refresh"></i></button>
        </div>
      </div>
      <ng-template #emptyQueue><p class="empty-queue">{{ 'reporting_analytics.no_jobs' | translate }}</p></ng-template>
    </section>
  </ng-container>

  <app-reports-tab *ngIf="activeModuleTab === 'reports'"></app-reports-tab>

  <app-subscriptions-tab
    *ngIf="activeModuleTab === 'subscriptions'"
    [latestDataset]="latestDataset"
    [locale]="locale"></app-subscriptions-tab>

  <app-archive-tab
    *ngIf="activeModuleTab === 'archive'"
    (openSession)="openSessionFromArchive($event)"></app-archive-tab>
</div>
